import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ConfirmationModalPopup from 'Components/ConfirmationModal/ConfirmationModalPopup';
import SelectInput from 'Components/forms/select-input/SelectInput.jsx';
import SmallButton from 'Components/Button/SmallButton';
import GeneratedReportIcon from 'Components/icons/GeneratedReportIcon';
import Badge from 'Components/Badge/';
import ReportIcon from 'Components/icons/ReportIcon';

import './DocumentCard.scss';

const DocumentCard = class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showConfirmation: false,
      confirmationBox: {
        header: '',
        actionText: '',
        cancelButtonText: '',
        dangerButtonText: '',
        action: null,
      },
      currentFilterValues: [],
    };

    this.attachBindings();
  }

  onSelectionChange(option) {
    const selectedOption = this.props.secondaryOptions.find((item) => item.value === option);
    if (selectedOption) {
      if (selectedOption.confirmAction) {
        this.setState({
          showConfirmation: true,
          confirmationBox: {
            header: selectedOption.confirmAction.header,
            actionText: selectedOption.confirmAction.actionText,
            cancelButtonText: selectedOption.confirmAction.cancelButtonText,
            dangerButtonText: selectedOption.confirmAction.dangerButtonText,
            action: selectedOption.action,
          },
        });
      } else if (selectedOption.showFileExport) {
        this.setState({
          showFileExport: true,
          reportId: selectedOption.reportId,
        });

        selectedOption.action(); // note: parent action
      } else {
        selectedOption.action();
      }
    }
  }

  cancelConfirmation() {
    this.setState({
      showConfirmation: false,
      confirmationBox: {
        header: '',
        actionText: '',
        cancelButtonText: '',
        dangerButtonText: '',
        action: null,
      },
    });
  }

  takeConfirmedAction() {
    this.state.confirmationBox.action();

    this.setState({
      showConfirmation: false,
      confirmationBox: {
        header: '',
        actionText: '',
        cancelButtonText: '',
        dangerButtonText: '',
        action: null,
      },
    });
  }

  attachBindings() {
    this.cancelConfirmation = this.cancelConfirmation.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.takeConfirmedAction = this.takeConfirmedAction.bind(this);
  }

  render() {
    const {
      children,
      title,
      description,
      primaryAction,
      primaryActionText,
      isNew,
      selectedInput,
      secondaryOptions,
      translations,
      document,
      isReportIcon,
    } = this.props;

    const {
      showConfirmation,
    } = this.state;

    const {
      actionText,
      cancelButtonText,
      dangerButtonText,
      header,
    } = this.state.confirmationBox;

    const newBadge = (isNew)
      ? (<Badge badgeType="success" info>{translations.new}</Badge>)
      : null;

    return (
      <div className="card report document-card">
        <div className="div__width">
          <div className="card-leftside-wrap">
           {isReportIcon ? <ReportIcon width={30} height={32}/> : <GeneratedReportIcon width={30} height={32} />}
            <span className="card__info">
              <span className="card__title">
                <div className="generated_report_name">
                  {title}
                </div>
                {newBadge}
              </span>
              <span className="card__description">
                {description}{children}
              </span>
            </span>
              <div className="card-rightside-wrap">
                <SmallButton action={primaryAction}>
                  {primaryActionText}
                </SmallButton> 
              </div>
          </div>
        </div>

        <div >  
          {
            secondaryOptions.length > 0 &&
            <SelectInput
              {...this.props}
              dataList={secondaryOptions}
              promptText={translations.more}
              wrapperClass="select-menu__form reports"
              handleSelection={this.onSelectionChange}
              selectedItem={selectedInput}
            />
          }
          {
            showConfirmation &&
            <ConfirmationModalPopup
              {...this.props}
              actionText={actionText}
              cancelButtonText={cancelButtonText}
              dangerAction={this.takeConfirmedAction}
              dangerButtonText={dangerButtonText}
              direction="down"
              title={header}
              toggleModal={this.cancelConfirmation}
            />
          }
        </div>
      </div>
    );
  }
};

DocumentCard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  primaryAction: PropTypes.func.isRequired,
  primaryActionText: PropTypes.string.isRequired,
  isNew: PropTypes.bool,
  selectedInput: PropTypes.object,
  secondaryOptions: PropTypes.array,
  translations: PropTypes.object,
  document: PropTypes.object,
  isReportIcon: PropTypes.bool,
};

DocumentCard.defaultProps = {
  children: '',
  description: '',
  isNew: false,
  selectedInput: {
    value: '',
    text: '',
    action: () => { },
  },
  secondaryOptions: [],
  translations: {
    apply: 'Export',
    cancel: 'Cancel',
    download: 'Download',
    draft: 'Draft',
    exportText: 'Export',
    exportingText: 'Exporting',
    exportTypesTitle: 'What do you want to export?',
    fileNameLabel: 'File Name',
    fileTypesTitle: 'Save As:',
    more: 'More',
    exportReport: 'Export Report',
    viewReport: 'View Report',
    emptySavedFilter: {
      title: 'A Saved Filter is required',
      subTitle: 'It looks like you don\'t have any saved filters to export this report.',
    },
  },
  document :{},
  isReportIcon:false,
};

export default DocumentCard;
